import { TaskStatusFilter } from './task-status-filter';
import { TaskPriorityFilter } from './task-priority-filter';
import { TaskAssigneeFilter } from './task-assignee-filter';
import { TaskWatcherFilter } from './task-watcher-filter';
import { InputFilterTrigger } from '@src/shared/features/views/components/static-filter-inputs';
import { createdAtFilterConfig } from '../../../configs/created-at-filter-config';
import { taskDueDateFilterConfig } from '../../../configs/task-due-date-filter-config';
import { TaskReporterFilter } from './task-reporter-filter';

export function TaskFilters() {
  return (
    <div className='flex flex-col gap-4'>
      <TaskReporterFilter />

      <TaskPriorityFilter />

      <TaskStatusFilter />

      <TaskAssigneeFilter />

      <TaskWatcherFilter />

      <InputFilterTrigger
        filterLabel='Created At'
        config={createdAtFilterConfig}
      />

      <InputFilterTrigger
        filterLabel='Due Date'
        config={taskDueDateFilterConfig}
      />
    </div>
  );
}
